const getTrackCheckDelaySeconds = () => {
  const rawMinutes = process.env.REACT_APP_TRACK_CHECK_DELAY_MINUTES ?? "";
  if (rawMinutes !== "") {
    const minutesValue = Number(rawMinutes);
    if (!isNaN(minutesValue) && minutesValue >= 0) {
      return Math.max(Math.round(minutesValue * 60), 1);
    }
  }

  const rawSeconds = process.env.REACT_APP_TRACK_CHECK_DELAY_SECONDS ?? "";
  if (rawSeconds === "") {
    return 3;
  }
  const intValue = parseInt(rawSeconds);
  if (isNaN(intValue)) {
    return 3;
  }
  return Math.max(intValue, 1);
};

const config = {
  api: {
    root: process.env.REACT_APP_API_ROOT ? process.env.REACT_APP_API_ROOT : window.location.origin,
    spotify_authentication_route: "/api/spotify/authenticate"
  },
  siteUrl: "https://spotify-lyrics-viewer.nitratine.net",
  client: {
    basename: process.env.REACT_APP_BASENAME,
    trackCheckDelaySeconds: getTrackCheckDelaySeconds()
  },
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
  }
};

export default config;
